@if (selectedBerater) {
  <nav class="consultant__topnav" data-profile-search-ignore>
    <div class="consultant__topnav-anchors">
      <button mat-button (click)="scrollTo('header')" [class.consultant__topnav-active]="activeSection === 'header'">
        <span class="consultant__topnav-label">
          @if (missingProfilCount > 0) {
            <div [matBadge]="missingProfilCount" matBadgeOverlap="false"
                 [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: missingProfilCount}"
                 class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.profile' | translate }}
            </div>
          } @else {
            {{ 'consultant.subheader.profile' | translate }}
          }
        </span>
      </button>

      <button mat-button (click)="scrollTo('personal')" [class.consultant__topnav-active]="activeSection === 'personal'">
        <span class="consultant__topnav-label">
          @if (missingPersonalDataCount > 0) {
            <div [matBadge]="missingPersonalDataCount" matBadgeOverlap="false"
                 [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: missingPersonalDataCount}"
                 class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.staff' | translate }}
            </div>
          } @else {
            {{ 'consultant.subheader.staff' | translate }}
          }
        </span>
      </button>
  
      <button mat-button (click)="scrollTo('education')" [class.consultant__topnav-active]="activeSection === 'education'">
        <span class="consultant__topnav-label">
          @if (missingEducationCount > 0) {
            <div [matBadge]="missingEducationCount" matBadgeOverlap="false"
                 [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: missingEducationCount}"
                 class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.education' | translate }}
            </div>
          } @else {
            {{ 'consultant.subheader.education' | translate }}
          }
        </span>
      </button>
  
      <button mat-button (click)="scrollTo('career')" [class.consultant__topnav-active]="activeSection === 'career'">
        <span class="consultant__topnav-label">
          @if (missingCareerCount > 0) {
            <div [matBadge]="missingCareerCount" matBadgeOverlap="false"
                 [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: missingCareerCount}"
                 class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.career' | translate }}
            </div>
          } @else {
            {{ 'consultant.subheader.career' | translate }}
          }
        </span>
      </button>
  
      <button mat-button (click)="scrollTo('trainings')" [class.consultant__topnav-active]="activeSection === 'trainings'">
        <span class="consultant__topnav-label">
          @if (missingTrainingCount > 0) {
            <div [matBadge]="missingTrainingCount" matBadgeOverlap="false"
                 [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: missingTrainingCount}"
                 class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.trainingCourses' | translate }}
            </div>
          } @else {
            {{ 'consultant.subheader.trainingCourses' | translate }}
          }
        </span>
      </button>
  
      <button mat-button (click)="scrollTo('certificates')" [class.consultant__topnav-active]="activeSection === 'certificates'">
        <span class="consultant__topnav-label">
        @if (missingCertificatesCount > 0) {
          <div [matBadge]="missingCertificatesCount" matBadgeOverlap="false"
               [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: missingCertificatesCount}"
               class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.certificates' | translate }}
          </div>
        } @else {
          {{ 'consultant.subheader.certificates' | translate }}
        }
        </span>
      </button>
  
      <button mat-button (click)="scrollTo('projects')" [class.consultant__topnav-active]="activeSection === 'projects'">
        <span class="consultant__topnav-label">
          @if (projectValidationErrorCount > 0) {
            <div [matBadge]="projectValidationErrorCount" matBadgeOverlap="false"
                 [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: projectValidationErrorCount}"
                 class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.projects' | translate }}
            </div>
          } @else {
            {{ 'consultant.subheader.projects' | translate }}
          }
        </span>
      </button>
  
      <button mat-button (click)="scrollTo('skills')" [class.consultant__topnav-active]="activeSection === 'skills'">
        <span class="consultant__topnav-label">
          @if (missingSkillCount > 0) {
            <div [matBadge]="missingSkillCount" matBadgeOverlap="false"
                 [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: missingSkillCount}"
                 class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.skills' | translate }}</div>
          } @else {
            {{ 'consultant.subheader.skills' | translate }}
          }
        </span>
      </button>
  
      @if (userService.hasRole("Office") || userService.hasRole('Admin') || userService.hasRole('Sale')) {
        <button mat-button (click)="scrollTo('ba-profile')" class="consultant__headercolor" [class.consultant__topnav-active]="activeSection === 'ba-profile'">
          <span class="consultant__topnav-label">{{ 'consultant.subheader.baProfile' | translate }}</span>
        </button>
      }
      @if (assignedCatalogs.length > 0) {
        <button mat-button (click)="scrollTo('ba-skills')" class="consultant__headercolor" [class.consultant__topnav-active]="activeSection === 'ba-skills'">
          <span class="consultant__topnav-label">
            @if (getTotalMissingBaSkills() > 0) {
              <div [matBadge]="getTotalMissingBaSkills()" matBadgeOverlap="false"
                   [matBadgeDescription]="'consultant.validation.badgeAria' | translate: {count: getTotalMissingBaSkills()}"
                   class="consultant__topnav-badge-wrapper">{{ 'consultant.subheader.baSkills' | translate }}</div>
            } @else {
              {{ 'consultant.subheader.baSkills' | translate }}
            }
          </span>
        </button>
      }
    </div>
    <button mat-icon-button type="button" class="consultant__topnav-search"
            [class.consultant__topnav-active]="profileSearch.isOpen()"
            [attr.aria-pressed]="profileSearch.isOpen()"
            [matTooltip]="(profileSearch.isOpen() ? 'profileSearch.close' : 'profileSearch.open') | translate"
            [attr.aria-label]="(profileSearch.isOpen() ? 'profileSearch.close' : 'profileSearch.open') | translate"
            (click)="profileSearch.toggle()">
      <mat-icon>search</mat-icon>
    </button>
  </nav>
  <app-profile-search #profileSearch></app-profile-search>
  <div class="consultant__berater-chapter">
    @if (selectedBerater?.id) {
      <div class="consultant__button">
        @if (userService.hasRole("Office") || userService.hasRole('Admin') || userService.hasRole('Sale')) {
          <button type="button" class="consultant__pill consultant__pill--fill" (click)="toggleExportMode()">
            @if (exportMode) {
              {{ 'consultant.applicant.toggleExportMode' | translate }}
            } @else {
              {{ 'consultant.applicant.exportMode' | translate }}
            }
          </button>
        }
        @if (userService.hasRole('Office') || userService.hasRole('Admin')) {
          <button type="button" class="consultant__pill consultant__pill--outline" (click)="openAiProfileMatching()">
            <svg viewBox="0 0 24 24" class="consultant__pill-icon" fill="none" stroke="currentColor" stroke-width="1.7"
                 stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M12 3l1.8 4.2L18 9l-4.2 1.8L12 15l-1.8-4.2L6 9l4.2-1.8Z"/>
              <path d="M18.5 15.5l.8 1.9 1.9.8-1.9.8-.8 1.9-.8-1.9-1.9-.8 1.9-.8Z"/>
            </svg>
            {{ 'consultant.applicant.aiProfileMatching' | translate }}
          </button>
        }
        @if (canImportCv && !exportMode) {
          <button type="button" class="consultant__pill consultant__pill--outline" (click)="importCv()">
            <mat-icon fontSet="material-symbols-outlined" class="consultant__pill-icon" aria-hidden="true">upload_file</mat-icon>
            {{ 'cvImport.uploadButton' | translate }}
          </button>
        }
      </div>
    }
    @if (draftProjectCount > 0 && !exportMode) {
      <p class="consultant__draft-export-hint">
        <mat-icon aria-hidden="true">info_outline</mat-icon>
        <span [innerHTML]="'consultant.draft.exportHint' | translate"></span>
      </p>
    }
    <a id="header" class="consultant__section-anchor"></a>
    <div class='consultant__header-div' [class.consultant__header-div--wip]="draftProjectCount > 0">
      <p class="consultant__header consultant__header-with-badge"
         [matBadge]="missingProfilCount > 0 ? missingProfilCount : null"
         [matBadgeHidden]="missingProfilCount === 0 || exportMode"
         matBadgeOverlap="false"
         [matBadgeDescription]="missingProfilCount > 0 ? ('consultant.validation.badgeAria' | translate: {count: missingProfilCount}) : ''">
        {{ selectedBerater?.vorname }} {{ selectedBerater?.nachname }}
      </p>
      @if (draftProjectCount > 0) {
        <span class="consultant__wip-chip">
          <span class="consultant__wip-dot" aria-hidden="true"></span>{{ 'consultant.draft.chip' | translate }}
        </span>
      }
      @if ((userService.hasRole("Office") || userService.hasRole('Admin')) && !exportMode) {
        <mat-icon class="consultant__header-edit" (click)='editConsultantName()'>edit</mat-icon>
      }
    </div>
    @if (userService.hasRole('Office') || userService.hasRole('Admin')) {
      <div class="consultant__checkbox-row">
        <div class="consultant__checkbox">
          <mat-checkbox [(ngModel)]='selectedBerater.applicant' (click)="saveApplicantChange()"></mat-checkbox>
          <mat-label>{{ 'consultant.applicant.isApplicant' | translate }}</mat-label>
        </div>
        <div class="consultant__checkbox">
          <mat-checkbox [(ngModel)]='selectedBerater.freelancer' (click)="saveFreelancerChange()"></mat-checkbox>
          <mat-label>{{ 'consultant.freelancer.isFreelancer' | translate }}</mat-label>
        </div>
      </div>
    }
    @if (hasValidationIssues && !exportMode) {
      <div class="consultant__validation-hint" role="status">
        <mat-icon>info_outline</mat-icon>
        <span>{{ 'consultant.validation.profileHint' | translate }}</span>
      </div>
    }
    @if (draftProjectCount > 0 && !exportMode) {
      <div class="consultant__draft-banner" role="status">
        <mat-icon aria-hidden="true">info_outline</mat-icon>
        <span>
          <span [innerHTML]="(draftProjectCount === 1 ? 'consultant.draft.bannerOne' : 'consultant.draft.bannerMany') | translate: { count: draftProjectCount }"></span>
          <button type="button" class="consultant__draft-link" (click)="jumpToDraft()">
            {{ 'consultant.draft.jumpToDraft' | translate }}
          </button>
        </span>
      </div>
    }
    <mat-divider class="consultant__divider-profile"></mat-divider>
    @if (!exportMode) {
      <div class="consultant__edit-button-div">
        @if (editMode) {
          <button
            mat-raised-button
            class="consultant__edit-btn consultant__edit-btn--text"
            (click)="onCancelEdit()"
          >
            {{ 'general.cancel' | translate }}
          </button>

          <button
            mat-icon-button
            class="consultant__edit-btn consultant__edit-btn--icon"
            (click)="onCancelEdit()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
        <button
          mat-flat-button
          class="consultant__edit-btn consultant__edit-btn--text"
          [disabled]="editMode && (!hasChangesIntro() || (selectedBerater.personaldaten.intro?.length || 0) < LIMITS.INTRO_MIN)"
          (click)="onToggleEdit()"
        >
          {{ editMode ? ('general.save' | translate) : ('general.edit' | translate) }}
        </button>

        <button
          mat-icon-button
          class="consultant__edit-btn consultant__edit-btn--icon"
          [disabled]="editMode && (!hasChangesIntro() || (selectedBerater.personaldaten.intro?.length || 0) < LIMITS.INTRO_MIN)"
          (click)="onToggleEdit()"
        >
          <mat-icon>{{ editMode ? 'save' : 'edit' }}</mat-icon>
        </button>
      </div>
    }

    <div class="consultant__berater-chapter-content">
      <div id="first-content" class="consultant__first-content">

        <div class="consultant__image-container">
          @if (this.selectedBerater?.personaldaten?.photos) {
            <div class="consultant__image-wrapper">
              <div class="consultant__image">
                <img
                  [src]="getProfilePhoto()"
                  alt="{{ 'consultant.consultantImage' | translate }}"
                  (error)="onImageError($event)"
                />
              </div>
            </div>
          } @else {
            <div class="consultant__image-wrapper">
              <div class="consultant__image">
                <img
                  ngSrc="./assets/img/no-picture.png" [fill]='true' class='consultant__image-file'
                  alt="{{ 'consultant.consultantImage' | translate }}"
                />
              </div>
            </div>
          }
          @if (!exportMode) {
            <app-field-warning [finding]="photoFinding"></app-field-warning>
          }
          <div class="consultant__image-actions">
            @if (!exportMode) {
              <button mat-icon-button (click)="selectedImages?.length ? openModalPictures() : handleClick()">
                <mat-icon>edit</mat-icon>
              </button>
            }
            <input
              type="file"
              id="upload-file"
              class="consultant__hidden"
              accept="image/*"
              (change)="onFilesSelectedModal($event)"
            />
            @for (img of selectedImages; track $index; let i = $index) {
              <input
                class="consultant__hidden"
                type="file"
                id="upload-file-replace-{{i}}"
                accept="image/*"
                (change)="onReplacePhoto($event, i)"
              />
            }
          </div>
        </div>

        @if (!editMode) {
          <div class="consultant__intro">
            <p [innerHTML]="selectedBerater.personaldaten.intro | linebreak"></p>
            <app-field-warning [finding]="introFinding"></app-field-warning>
          </div>
        } @else {
          <div class="consultant__intro-edit">
            <div class="consultant__intro-label-row">
              <mat-label class="consultant__intro-label">{{ 'consultant.introLabel' | translate }}</mat-label>
              <app-field-hint [text]="'tooltip.beraterIntro' | translate" align="start"></app-field-hint>
            </div>
            <mat-form-field class="consultant__intro-field" appearance="outline">
              <textarea
                matInput
                required
                [attr.aria-label]="'consultant.introLabel' | translate"
                [(ngModel)]="selectedBerater.personaldaten.intro"
                [minlength]="LIMITS.INTRO_MIN"
                [maxlength]="LIMITS.INTRO"
                class="consultant__textarea"
                #introField="ngModel"
              ></textarea>
              @if (introField.invalid && introField.touched) {
                <mat-error>{{
                  (introField.errors?.['minlength']
                    ? 'general.validation.minLength'
                    : 'consultant.introRequired') | translate: {min: LIMITS.INTRO_MIN}
                }}</mat-error>
              }
            </mat-form-field>
            <div class="consultant__intro-counter">
              <span [class.consultant__character-limit--error]="(selectedBerater.personaldaten.intro?.length || 0) < LIMITS.INTRO_MIN">
                {{ selectedBerater.personaldaten.intro?.length || 0 }}/{{ (selectedBerater.personaldaten.intro?.length || 0) < LIMITS.INTRO_MIN ? LIMITS.INTRO_MIN : LIMITS.INTRO }}
              </span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="consultant__berater-chapter">
    <a id="personal" class="consultant__section-anchor"></a>
    <p class="consultant__header consultant__header-with-badge"
       [matBadge]="missingPersonalDataCount > 0 ? missingPersonalDataCount : null"
       [matBadgeHidden]="missingPersonalDataCount === 0"
       matBadgeOverlap="false"
       [matBadgeDescription]="missingPersonalDataCount > 0 ? ('consultant.validation.badgeAria' | translate: {count: missingPersonalDataCount}) : ''">{{ 'consultant.headerTitle.personalData' | translate }}</p>
    <mat-divider class="consultant__divider-profile"></mat-divider>
    <div class="consultant__berater-chapter-content">
      <app-personal-data
        [findings]="personalDataFindings"
        [personalData]="selectedBerater.personaldaten"
        [consultant]="selectedBerater"
        [isApplicant]="selectedBerater.applicant"
        [exportMode]='exportMode'
        [twoPagerMode]='twoPagerMode'
        [forcedSchwerpunkte]="forcedSchwerpunkte"
        [forcedBranchen]="forcedBranchen"
        (exportSelectionChange)="onExportSelectionChange($event, 'personal')"
        (industriesExportSelectionChange)="onExportSelectionChange($event, 'industries')"
        (saved)="onSectionSaved($event)"
      ></app-personal-data>
    </div>
  </div>
  <div class="consultant__berater-chapter">
    <a id="education" class="consultant__section-anchor"></a>
    <div class="consultant__section-header-row">
      <p class="consultant__header consultant__header-with-badge"
         [matBadge]="missingEducationCount > 0 ? missingEducationCount : null"
         [matBadgeHidden]="missingEducationCount === 0"
         matBadgeOverlap="false"
         [matBadgeDescription]="missingEducationCount > 0 ? ('consultant.validation.badgeAria' | translate: {count: missingEducationCount}) : ''">{{ 'consultant.headerTitle.education' | translate }}</p>
      @if (exportMode && !twoPagerMode) {
        <mat-checkbox
          [checked]="isSectionAllSelected('education', selectedBerater.ausbildung?.length ?? 0)"
          [indeterminate]="isSectionSomeSelected('education') && !isSectionAllSelected('education', selectedBerater.ausbildung?.length ?? 0)"
          (change)="toggleSectionAll('education', $event.checked)"
        ></mat-checkbox>
      }
    </div>
    <mat-divider class="consultant__divider-profile"></mat-divider>
    <div class="consultant__berater-chapter-content">
      <app-education
        [findings]="educationFindings"
        [ausbildung]="selectedBerater.ausbildung"
        [berater]="selectedBerater"
        [exportMode]='exportMode'
        [twoPagerMode]='twoPagerMode'
        [forcedSelectedIds]="forcedEducationIds"
        (exportSelectionChange)="onExportSelectionChange($event, 'education')"
        (saved)="onSectionSaved($event)"
      ></app-education>
    </div>
  </div>
  <div class="consultant__berater-chapter">
    <a id="career" class="consultant__section-anchor"></a>
    <div class="consultant__section-header-row">
      <p class="consultant__header consultant__header-with-badge"
         [matBadge]="missingCareerCount > 0 ? missingCareerCount : null"
         [matBadgeHidden]="missingCareerCount === 0"
         matBadgeOverlap="false"
         [matBadgeDescription]="missingCareerCount > 0 ? ('consultant.validation.badgeAria' | translate: {count: missingCareerCount}) : ''">{{ 'consultant.headerTitle.career' | translate }}</p>
      @if (exportMode && !twoPagerMode) {
        <mat-checkbox
          [checked]="isSectionAllSelected('career', selectedBerater.werdegang?.length ?? 0)"
          [indeterminate]="isSectionSomeSelected('career') && !isSectionAllSelected('career', selectedBerater.werdegang?.length ?? 0)"
          (change)="toggleSectionAll('career', $event.checked)"
        ></mat-checkbox>
      }
    </div>
    <mat-divider class="consultant__divider-profile"></mat-divider>
    <div class="consultant__berater-chapter-content">
      <app-career
        [findings]="careerFindings"
        [werdegang]="selectedBerater.werdegang"
        [berater]="selectedBerater"
        [exportMode]='exportMode'
        [twoPagerMode]='twoPagerMode'
        [forcedSelectedIds]="forcedCareerIds"
        (exportSelectionChange)="onExportSelectionChange($event, 'career')"
        (saved)="onSectionSaved($event)"
      ></app-career>
    </div>
  </div>
  <div class="consultant__berater-chapter">
    <a id="trainings" class="consultant__section-anchor"></a>
    <div class="consultant__section-header-row">
      <p class="consultant__header consultant__header-with-badge"
         [matBadge]="missingTrainingCount > 0 ? missingTrainingCount : null"
         [matBadgeHidden]="missingTrainingCount === 0"
         matBadgeOverlap="false"
         [matBadgeDescription]="missingTrainingCount > 0 ? ('consultant.validation.badgeAria' | translate: {count: missingTrainingCount}) : ''">{{ 'consultant.headerTitle.training' | translate }}</p>
      @if (exportMode && !twoPagerMode) {
        <mat-checkbox
          [checked]="isSectionAllSelected('trainings', selectedBerater.schulungen?.length ?? 0)"
          [indeterminate]="isSectionSomeSelected('trainings') && !isSectionAllSelected('trainings', selectedBerater.schulungen?.length ?? 0)"
          (change)="toggleSectionAll('trainings', $event.checked)"
        ></mat-checkbox>
      }
    </div>
    <mat-divider class="consultant__divider-profile"></mat-divider>
    <div class="consultant__berater-chapter-content">
      <app-trainings
        [findings]="trainingFindings"
        [schulungen]="selectedBerater.schulungen"
        [berater]="selectedBerater"
        [exportMode]='exportMode'
        [twoPagerMode]='twoPagerMode'
        [forcedSelectedIds]="forcedTrainingIds"
        (exportSelectionChange)="onExportSelectionChange($event, 'trainings')"
        (saved)="onSectionSaved($event)"
      ></app-trainings>
    </div>
  </div>
  <div class="consultant__berater-chapter">
    <a id="certificates" class="consultant__section-anchor"></a>
    <div class="consultant__section-header-row">
      <p class="consultant__header consultant__header-with-badge"
         [matBadge]="missingCertificatesCount > 0 ? missingCertificatesCount : null"
         [matBadgeHidden]="missingCertificatesCount === 0"
         matBadgeOverlap="false"
         [matBadgeDescription]="missingCertificatesCount > 0 ? ('consultant.validation.badgeAria' | translate: {count: missingCertificatesCount}) : ''">{{ 'consultant.headerTitle.certificates' | translate }}</p>
      @if (exportMode && !twoPagerMode) {
        <mat-checkbox
          [checked]="isSectionAllSelected('certificates', selectedBerater.zertifikate?.length ?? 0)"
          [indeterminate]="isSectionSomeSelected('certificates') && !isSectionAllSelected('certificates', selectedBerater.zertifikate?.length ?? 0)"
          (change)="toggleSectionAll('certificates', $event.checked)"
        ></mat-checkbox>
      }
    </div>
    <mat-divider class="consultant__divider-profile"></mat-divider>
    <div class="consultant__berater-chapter-content">
      <app-certificates
        [findings]="certificateFindings"
        [certificates]="selectedBerater.zertifikate"
        [berater]="selectedBerater"
        [exportMode]='exportMode'
        [twoPagerMode]='twoPagerMode'
        [forcedSelectedIds]="forcedCertificateIds"
        (changedCertificates)='onSectionSaved($event)'
        (exportSelectionChange)="onExportSelectionChange($event, 'certificates')"
      ></app-certificates>
    </div>
  </div>
  <div class="consultant__berater-chapter">
    <a id="projects" class="consultant__section-anchor"></a>
    <p class="consultant__header consultant__header-with-badge"
       [matBadge]="projectValidationErrorCount > 0 ? projectValidationErrorCount : null"
       [matBadgeHidden]="projectValidationErrorCount === 0"
       matBadgeOverlap="false"
       [matBadgeDescription]="projectValidationErrorCount > 0 ? ('consultant.validation.badgeAria' | translate: {count: projectValidationErrorCount}) : ''">{{ 'consultant.headerTitle.projects' | translate }}
      ({{ selectedBerater.projekte.length }})</p>
    <mat-divider class="consultant__divider-profile"></mat-divider>
    <div class="consultant__berater-chapter-content">
      <app-projects
        [projects]="selectedBerater.projekte"
        [berater]="selectedBerater"
        [exportMode]='exportMode'
        [twoPagerMode]='twoPagerMode'
        [maxProjects]="maxProjectsForPages"
        [selectedSkillIds]="exportSelections['skills']"
        [skillBudgetReached]="twoPagerSkillBudgetFull"
        [forcedProjectsData]="forcedProjectsData"
        [canSaveDraft]="isOwnProfile"
        [openProjectUuid]="deepLinkedProjectUuid"
        (projectSaved)="onProjectSaved($event)"
        (faehigkeitenReloaded)="onProjectFaehigkeitenReloaded($event)"
        (exportSelectionChange)="onProjectListSelectionChange($event, 'projects')"
        (methodSelectionChange)="onProjectListSelectionChange($event, 'methods')"
        (skillSelectionChange)="onSkillsSelectionChange($event)"
        (projectsExportDataChange)="onProjectsExportDataChange($event)"
      ></app-projects>
    </div>
  </div>
  <div class="consultant__berater-chapter">
    <a id="skills" class="consultant__section-anchor"></a>
    <p class="consultant__header consultant__header-with-badge"
       [matBadge]="missingSkillCount > 0 ? missingSkillCount : null"
       [matBadgeHidden]="missingSkillCount === 0"
       matBadgeOverlap="false"
       [matBadgeDescription]="missingSkillCount > 0 ? ('consultant.validation.badgeAria' | translate: {count: missingSkillCount}) : ''">{{ 'consultant.headerTitle.skills' | translate }}</p>
    <mat-divider class="consultant__divider-profile"></mat-divider>
    <div class="consultant__berater-chapter-content">
      <app-skills
        [skills]="selectedBerater.faehigkeiten"
        [findings]="skillFindings"
        [consultant]="selectedBerater"
        (projectSkill)="reloadConsultant()"
        [exportMode]='exportMode'
        [twoPagerMode]='twoPagerMode'
        [selectedSkillIds]="exportSelections['skills']"
        [forcedSelectedIds]="forcedSkillIds"
        (exportSelectionChange)="onSkillsSelectionChange($event)"
      ></app-skills>
    </div>
  </div>

  @if (userService.hasRole("Office") || userService.hasRole('Admin') || userService.hasRole('Sale')) {
    <div class="consultant__berater-chapter">
      <a id="ba-profile" class="consultant__section-anchor"></a>
      <p
        class="consultant__header consultant__headercolor">{{ 'consultant.headerTitle.employmentAgencyRole' | translate }}</p>
      <mat-divider class="consultant__divider-profile"></mat-divider>
      <div class="consultant__berater-chapter-content">
        <app-roles-ba [berater]="selectedBerater" (saved)="onCatalogAssignmentsSaved($event)"
                      [assignedCatalogs]="assignedCatalogs"
                      [exportMode]='exportMode'
                      [twoPagerMode]='twoPagerMode'
                      (reloadRequired)="reloadConsultant()"
                      (exportSelectionChange)="onExportSelectionChange($event, 'rolesBa')"></app-roles-ba>
      </div>
    </div>
  }
  @if (assignedCatalogs.length > 0) {
    <div class="consultant__berater-chapter">
      <a id="ba-skills" class="consultant__section-anchor"></a>
      <p class="consultant__header consultant__headercolor consultant__header-with-badge"
         [matBadge]="getTotalMissingBaSkills() > 0 ? getTotalMissingBaSkills() : null"
         [matBadgeHidden]="getTotalMissingBaSkills() === 0"
         matBadgeOverlap="false"
         [matBadgeDescription]="getTotalMissingBaSkills() > 0 ? ('consultant.validation.badgeAria' | translate: {count: getTotalMissingBaSkills()}) : ''">
        {{ 'consultant.headerTitle.baSkills' | translate }}
      </p>
      <mat-divider class="consultant__divider-profile"></mat-divider>

      <div class="consultant__bewertungsschema">
        <p class="consultant__bewertungsschema-title">{{ 'skills.bewertungsschema.title' | translate }}</p>
        <div class="consultant__bewertungsschema-cards">
          <div class="consultant__bewertungsschema-card consultant__bewertungsschema-card--basic">
            <span class="consultant__bewertungsschema-card-label">{{ 'skills.BA_LEVEL.BASIC' | translate }}</span>
            <p class="consultant__bewertungsschema-card-desc">{{ 'skills.bewertungsschema.basic' | translate }}</p>
          </div>
          <div class="consultant__bewertungsschema-card consultant__bewertungsschema-card--advanced">
            <span class="consultant__bewertungsschema-card-label">{{ 'skills.BA_LEVEL.ADVANCED' | translate }}</span>
            <p class="consultant__bewertungsschema-card-desc">{{ 'skills.bewertungsschema.advanced' | translate }}</p>
          </div>
          <div class="consultant__bewertungsschema-card consultant__bewertungsschema-card--special">
            <span class="consultant__bewertungsschema-card-label">{{ 'skills.BA_LEVEL.SPECIAL' | translate }}</span>
            <p class="consultant__bewertungsschema-card-desc">{{ 'skills.bewertungsschema.special' | translate }}</p>
          </div>
        </div>
      </div>

      <div class="consultant__toolbar consultant__edit-button-div">
        <button mat-stroked-button (click)="toggleAll(true)">
          {{ 'general.expandAll' | translate }}
        </button>
        <button mat-stroked-button (click)="toggleAll(false)">
          {{ 'general.collapseAll' | translate }}
        </button>
      </div>

      <mat-accordion multi="true" class="consultant__accordion">
        @for (catalogues of assignedCatalogs; track catalogues.id) {
          <mat-expansion-panel
            class="consultant__expansion-panel mat-mdc-card mdc-card"
            [(expanded)]="panelOpenState[catalogues.id]"
          >
            <mat-expansion-panel-header class="consultant__expansion-panel-header">
              <mat-panel-title class="consultant__expansion-panel-title">
                <div class="consultant__expansion-panel-title-row">
                  <p>
                    @if (catalogues.rollenbezeichnung.toString().toLowerCase().includes("allegro")) {
                      (ALLEGRO)
                    } @else {
                      (RVSE{{ catalogues.rvseVersion }})
                    }
                    {{ 'baCatalog.roleBa.pg' | translate }}
                    {{ catalogues.preisgruppe }} - {{ catalogues.bezeichnung }}
                  </p>

                  @if (hasMissingBaSkills(catalogues)) {
                    <span class="consultant__ba-summary-badge">
                    {{ getMissingBaSkillCount(catalogues) }}
                      {{ (getMissingBaSkillCount(catalogues) === 1 ? 'general.requirementField' : 'general.requirementFields') | translate }}
                  </span>
                  }
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-divider class="consultant__divider-profile"></mat-divider>

            <div class="consultant__berater-chapter-content">
              <app-skills-ba
                [catalog]="catalogues"
                [consultant]="selectedBerater"
                [exportMode]='exportMode'
                (saved)="onCatalogAssignmentsSaved($event)"
              ></app-skills-ba>
            </div>
          </mat-expansion-panel>
        }
      </mat-accordion>

      <div class="consultant__placeholder"></div>
    </div>
  }
  @if (exportMode) {
    <app-export-bar
      [selectedCount]="totalExportCount"
      [showPreselectionHint]="showPreselectionHint"
      [configurations]="filteredExportConfigurations"
      [selectedConfigId]="selectedConfigId"
      [language]="exportLanguage"
      [twoPagerMode]="twoPagerMode"
      [pageCount]="twoPagerPageCount"
      [includeProfilePicture]="includeProfilePicture"
      [running]="isExporting"
      (languageChange)="setExportLanguage($event)"
      (twoPagerModeChange)="setTwoPagerMode($event)"
      (pageCountChange)="setPageCount($event)"
      (pictureToggle)="toggleProfilePicture()"
      (configSelected)="onConfigSelected($event)"
      (deleteConfig)="openDeleteConfigModal()"
      (download)="onSendClick('download')"
      (sendToTeams)="onSendClick('teams')"
      (cancel)="toggleExportMode()"
    >
      @if (twoPagerMode) {
        <div class="twopager-summary-panel">
          <div class="twopager-summary-row" [class.is-full]="twoPagerSkillBudgetFull">
            <mat-icon>{{ twoPagerSkillBudgetFull ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            <span>{{ twoPagerSkillRowsUsed }}/{{ twoPagerSkillRowsMax }} {{ 'consultant.twoPager.hint.skillRows' | translate: {
              skills: twoPagerTotalSkillCount,
              categories: twoPagerSkillCategoryCount
            } }}</span>
          </div>
          <div class="twopager-summary-row" [class.is-full]="twoPagerCertCount >= 6">
            <mat-icon>{{ twoPagerCertCount >= 6 ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            <span>{{ twoPagerCertCount }}/6 {{ 'consultant.twoPager.hint.certificates' | translate }}</span>
          </div>
          <div class="twopager-summary-row" [class.is-full]="twoPagerSchwerpunkteCount >= 5">
            <mat-icon>{{ twoPagerSchwerpunkteCount >= 5 ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            <span>{{ twoPagerSchwerpunkteCount }}/5 {{ 'consultant.twoPager.hint.schwerpunkte' | translate }}</span>
          </div>
          <div class="twopager-summary-row" [class.is-full]="twoPagerBranchenCount >= twoPagerMaxBranchen">
            <mat-icon>{{ twoPagerBranchenCount >= twoPagerMaxBranchen ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
            <span>{{ twoPagerBranchenCount }}/{{ twoPagerMaxBranchen }} {{ 'consultant.twoPager.hint.industries' | translate }}</span>
          </div>
          @if (maxProjectsForPages === 0) {
            <div class="twopager-summary-row is-full">
              <mat-icon>check_circle</mat-icon>
              <span>{{ 'consultant.twoPager.noProjects' | translate }}</span>
            </div>
          } @else {
            <div class="twopager-summary-row" [class.is-full]="twoPagerProjectsValid">
              <mat-icon>{{ twoPagerProjectsValid ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
              <span>{{ twoPagerProjectCount }} {{ 'consultant.twoPager.hint.projects' | translate }}
                ({{ minProjectsForPages }}–{{ maxProjectsForPages }})</span>
            </div>
          }
          @for (project of twoPagerProjectBreakdown; track project.uuid) {
            <div class="twopager-summary-row twopager-summary-row--detail">
              <mat-icon>subdirectory_arrow_right</mat-icon>
              <span>{{ project.name }}: {{ project.taskCount }} {{ 'consultant.twoPager.hint.tasks' | translate }} ·
                {{ project.methodCount }}/3 {{ 'consultant.twoPager.hint.methods' | translate }} ·
                {{ project.skillCount }} {{ 'consultant.twoPager.hint.skills' | translate }}</span>
            </div>
          }
        </div>
      }
    </app-export-bar>
    <div class="consultant__export-spacer" aria-hidden="true"></div>
  }
}


<app-modal
  modalId='editConsultant'
  (save)='saveConsultant()'
  [title]="'consultant.editNameModal.header'"
  [(visible)]="editConsultantModalShow"
  [showButtons]="true"
  [disabled]="!hasChangesName() || !isValid()"
  (cancel)='closeEditModal()'
  [showClose]="true"
  [contentTemplate]='editConsultantTemplate'
  [saveText]="'general.save'"
>
</app-modal>

<ng-template #editConsultantTemplate>
  <mat-form-field class='consultant__edit-name-form'>
    <mat-label>{{ 'consultant.editNameModal.firstname' | translate }}</mat-label>
    <input matInput required [(ngModel)]='selectedBerater.vorname' [maxlength]="LIMITS.NAME" #vornameField="ngModel">
    @if (selectedBerater?.vorname === "") {
      <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
    }
    @if (vornameField.errors?.['maxlength']) {
      <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.NAME } }}</mat-error>
    }
  </mat-form-field>
  <mat-form-field class='consultant__edit-name-form'>
    <mat-label>{{ 'consultant.editNameModal.lastname' | translate }}</mat-label>
    <input matInput required [(ngModel)]='selectedBerater.nachname' [maxlength]="LIMITS.NAME" #nachnameField="ngModel">
    @if (selectedBerater?.nachname === "") {
      <mat-error>{{ 'general.errors.required' | translate }}</mat-error>
    }
    @if (nachnameField.errors?.['maxlength']) {
      <mat-error>{{ 'general.validation.maxLength' | translate: { max: LIMITS.NAME } }}</mat-error>
    }
  </mat-form-field>
</ng-template>


<app-modal
  modalId='seePictures'
  [title]="'consultant.imageModal.header'"
  [(visible)]="seePicturesModalShow"
  [showButtons]="false"
  [showClose]="true"
  [contentTemplate]='seePicturesTemplate'
  [text]="'consultant.imageModal.subheader'"
>
</app-modal>

<ng-template #seePicturesTemplate>
  <div class='consultant__outer-picture'>
    @for (img of selectedImages; track $index; let i = $index; let last = $last) {
      <div class='consultant__inner-picture'>

        @if (replacingIndex === i) {
          <div class="consultant__image-loading">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        } @else {
          <img [src]="getThumbnailUrl(img)" width="150" [class.primary]="i === 0" (click)="setAsPrimary(i)"/>
        }

        <div>
          <button mat-icon-button (click)="setAsPrimary(i)" [disabled]='i === 0'>
            <mat-icon>favorite</mat-icon>
          </button>
          <button mat-icon-button (click)='handleClickReplace(i)' [disabled]='replacingIndex === i'>
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)='openDeleteModal(i)' class='consultant__delete-icon'
                  [disabled]='replacingIndex === i'>
            <mat-icon>delete</mat-icon>
          </button>
          <button mat-icon-button (click)='downloadImage(i)' [disabled]='replacingIndex === i'>
            <mat-icon>download</mat-icon>
          </button>
        </div>
      </div>
      <input
        class="consultant__hidden"
        type="file"
        id="upload-file-modal-multiple"
        name="file"
        accept="image/*"
        multiple
        (change)="onFilesSelectedModal($event)"
      />
      @if (last && i < 2) {
        <button mat-icon-button (click)='handleClickModalMultiple()' class='consultant__add-image-icon'>
          <mat-icon>add_photo_alternate</mat-icon>
        </button>
      }
    }
  </div>
</ng-template>

<app-modal
  modalId='deletePicture'
  [title]="'consultant.deleteModal.header'"
  [text]="'consultant.deleteModal.subheader'"
  [(visible)]="showDeleteModal"
  [showButtons]="true"
  (cancel)='closeDeleteModal()'
  (save)='deleteImage(selectedIndex)'
  [showClose]="true"
  [contentTemplate]='deleteImageModal'
  [saveText]="'general.delete'"
>
</app-modal>

<ng-template #deleteImageModal>
  <img [src]='getThumbnailUrl(selectedImages[selectedIndex])' class='consultant__delete-image'>
</ng-template>

<app-export-save-dialog
  [(visible)]="showExportNameModal"
  [(name)]="profileName"
  [maxLength]="LIMITS.EXPORT_CONFIG_NAME"
  (saved)="sendExportProfile()"
  (exportWithoutSaving)="exportWithoutSaving()"
  (cancelled)="profileName = ''"
></app-export-save-dialog>

@if (showDeleteConfigModal) {
  <div class="export-delete-dialog__backdrop" (click)="showDeleteConfigModal = false"></div>
  <div class="export-delete-dialog__card" role="dialog" aria-modal="true" aria-labelledby="export-delete-dialog-title">
    <div class="export-delete-dialog__modal-head">
      <div id="export-delete-dialog-title" class="export-delete-dialog__modal-title">
        {{ 'consultant.export.deleteConfig.title' | translate }}
      </div>
      <button class="export-delete-dialog__modal-x" type="button" [attr.aria-label]="'general.close' | translate"
              (click)="showDeleteConfigModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="export-delete-dialog__modal-body">
      <p class="export-delete-dialog__modal-text">{{ 'consultant.export.deleteConfig.confirm' | translate }}</p>
    </div>
    <div class="export-delete-dialog__modal-foot">
      <div class="export-delete-dialog__modal-actions">
        <button type="button" class="export-delete-dialog__btn-text" (click)="showDeleteConfigModal = false">
          {{ 'general.cancel' | translate }}
        </button>
        <button type="button" class="export-delete-dialog__btn-danger" (click)="deleteSelectedConfig()">
          {{ 'general.delete' | translate }}
        </button>
      </div>
    </div>
  </div>
}

@if (showCloseExportModal) {
  <div class="export-close-dialog__backdrop" (click)="showCloseExportModal = false"></div>
  <div class="export-close-dialog__card" role="dialog" aria-modal="true" aria-labelledby="export-close-dialog-title">
    <div class="export-close-dialog__modal-head">
      <div id="export-close-dialog-title" class="export-close-dialog__modal-title">
        {{ 'consultant.export.closeModal.title' | translate }}
      </div>
      <button class="export-close-dialog__modal-x" type="button" [attr.aria-label]="'general.close' | translate"
              (click)="showCloseExportModal = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="export-close-dialog__modal-body">
      @if (configDirty) {
        <p class="export-close-dialog__modal-text">{{ 'consultant.export.closeModal.unsavedChanges' | translate }}</p>
        <label class="export-close-dialog__field-label" for="export-close-dialog-name">{{ 'consultant.export.modal.nameLabel' | translate }}</label>
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="export-close-dialog__name-field">
          <input matInput id="export-close-dialog-name" [(ngModel)]="closeExportProfileName" [maxlength]="LIMITS.EXPORT_CONFIG_NAME"
                 [placeholder]="'consultant.export.modal.namePlaceholder' | translate"/>
        </mat-form-field>
      } @else {
        <p class="export-close-dialog__modal-text">{{ 'consultant.export.closeModal.confirm' | translate }}</p>
      }
    </div>
    <div class="export-close-dialog__modal-foot">
      <div class="export-close-dialog__modal-actions">
        <button type="button" class="export-close-dialog__btn-text" (click)="showCloseExportModal = false">
          {{ 'general.cancel' | translate }}
        </button>
        @if (configDirty) {
          <button type="button" class="export-close-dialog__btn-text export-close-dialog__without-saving"
                  (click)="confirmCloseExport()">
            {{ 'consultant.export.closeModal.closeWithoutSaving' | translate }}
          </button>
        }
        <button type="button" class="export-close-dialog__btn-primary"
                [disabled]="configDirty && !closeExportProfileName?.trim()"
                (click)="configDirty ? saveConfigAndCloseExport() : confirmCloseExport()">
          {{ (configDirty ? 'consultant.export.closeModal.saveAndClose' : 'consultant.export.closeModal.close') | translate }}
        </button>
      </div>
    </div>
  </div>
}

<app-twopager-save-dialog
  [(visible)]="showTemplateConflictModal"
  [conflictingName]="conflictingTemplateName"
  [existingNames]="existingTemplateNames"
  (updateExisting)="onTemplateConflictUpdate()"
  (saveAsNew)="onTemplateConflictSaveAs($event)"
  (cancelled)="onTemplateConflictCancelled()"
></app-twopager-save-dialog>

<app-twopager-save-dialog
  variant="changedOnExport"
  [(visible)]="showLoadedTemplateModal"
  [conflictingName]="loadedTemplateName"
  [existingNames]="existingTemplateNames"
  (updateExisting)="onLoadedTemplateOverwrite()"
  (saveAsNew)="onLoadedTemplateSaveAs($event)"
  (skipSave)="onLoadedTemplateSkipSave()"
></app-twopager-save-dialog>

<app-twopager-save-dialog
  variant="changedOnClose"
  [(visible)]="showCloseTemplateModal"
  [conflictingName]="loadedTemplateName"
  [existingNames]="existingTemplateNames"
  (updateExisting)="onCloseTemplateOverwrite()"
  (saveAsNew)="onCloseTemplateSaveAs($event)"
  (skipSave)="onCloseTemplateDiscard()"
></app-twopager-save-dialog>

<app-export-template-dialog
  [(visible)]="showTemplateDialog"
  [available]="availableTemplates"
  [selection]="exportTemplates"
  (confirmed)="onTemplatesConfirmed($event)"
  (cancelled)="onTemplatesCancelled()"
></app-export-template-dialog>

<app-toast [message]="toastMessage ? (toastMessage | translate) : null" (dismissed)="toastMessage = null"></app-toast>
